import * as React from 'react'
import {  useSelector } from 'react-redux'
import { MainMenu } from './mainmenu/menu'
import { currentHubSelector, visibleHubSelector } from '../selectors/hub'
import { RootState } from '../types/rootstate'
import { resizingComponent } from './resizingcomponent'

interface Props {
  name: string
  extraCssClasses?: string[]
}

export const Container: React.FC<React.PropsWithChildren<Props>> = ({ name, extraCssClasses, children }) => {
  const visibleHub: RootState['hub'] = useSelector(visibleHubSelector)
  const currentHubItem: RootState['hub'][0] = useSelector(currentHubSelector)
  const streamStatus: RootState['stream']['status'] = useSelector((state: RootState) => state.stream.status)

  const hasMainMenu = visibleHub && visibleHub.length > 1
  const extraCssClassesAsString = extraCssClasses && extraCssClasses.length > 0
    ? ' ' + extraCssClasses.join(' ') : ''
  const groupIdClass = (currentHubItem &&
    currentHubItem.groupId &&
    ` tabitem-groupid-${currentHubItem.groupId}`) || ''

  return (

      <div
        ref={(node) => resizingComponent.setRef(node, 'widget')}
        className={'imbox-' +
        (name) +
        (groupIdClass) +
        (hasMainMenu ? ' hasMainMenu' : '') +
        (extraCssClassesAsString) +
        (streamStatus === 'incall' ? ' imbox-incall' : '')}
      >
        {children}
        <MainMenu />
      </div>

  )
}
